import { render, staticRenderFns } from "./Editor-Personal.vue?vue&type=template&id=09e4f1da"
import script from "./Editor-Personal.vue?vue&type=script&lang=ts"
export * from "./Editor-Personal.vue?vue&type=script&lang=ts"
import style0 from "./Editor-Personal.vue?vue&type=style&index=0&id=09e4f1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports